// import 'babel-polyfill';
import React from 'react';
import { spy } from 'mobx';
import ReactDOM from 'react-dom';
import { MemoryRouter as Router } from 'react-router-dom';
import { configure } from '@elevio/elevio-frontend-utils/dist/diagnostics';
import 'reset-css/reset.css';
import Routes from './Routes';
import './style.css';

configure(
  {
    accessToken: '826e905d4a254598a71a221be32215cf',
    environment: process.env.DEPLOY_ENV,
    code_version: '{{GIT_COMMIT_SHA}}',
  },
  console.error, // eslint-disable-line no-console
  spy
);

ReactDOM.render(
  <Router>
    <Routes />
  </Router>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/main.js